/* ═══════════════════════════════════════════════════════════════
   KITE (DISCOUNT & FREE GIFT) APP SYNC
   The Kite app adds/removes free gifts via its own AJAX calls, so
   the theme drawer never hears about them. This intercepts any
   cart mutation that didn't come from the theme (theme requests
   always send a "sections" payload) and re-renders the drawer.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  if (window.__cartAppSyncInstalled) return;
  window.__cartAppSyncInstalled = true;

  const CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?([/?]|$)/;
  let refreshTimer = null;
  let isRefreshing = false;

  function bodyHasSections(body) {
    if (!body) return false;
    if (typeof body === 'string') return body.indexOf('sections') !== -1;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      return body.has('sections') || body.has('sections_url');
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      return body.has('sections') || body.has('sections_url');
    }
    return false;
  }

  async function refreshCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || isRefreshing) return;
    isRefreshing = true;

    try {
      const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      const response = await fetch(`${cartUrl}?sections=cart-drawer,cart-icon-bubble`);
      const sections = await response.json();

      if (sections['cart-drawer']) {
        const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const newInner = parsed.querySelector('.drawer__inner');
        const currentInner = drawer.querySelector('.drawer__inner');
        if (newInner && currentInner) currentInner.innerHTML = newInner.innerHTML;

        const newDrawer = parsed.querySelector('cart-drawer');
        if (newDrawer) drawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
      }

      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sections['cart-icon-bubble']) {
        const parsedBubble = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const newBubble = parsedBubble.querySelector('.shopify-section');
        if (newBubble) bubble.innerHTML = newBubble.innerHTML;
      }

      document.dispatchEvent(new CustomEvent('cart-drawer:rendered'));
    } catch (error) {
      console.error('[cart-app-sync] Drawer refresh failed:', error);
    } finally {
      isRefreshing = false;
    }
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCartDrawer, 350);
  }

  // Intercept fetch-based cart mutations (Kite and most apps use fetch)
  const originalFetch = window.fetch;
  window.fetch = function (resource, options) {
    let url = '';
    if (typeof resource === 'string') url = resource;
    else if (resource && typeof resource.url === 'string') url = resource.url;

    const isAppCartMutation = CART_MUTATION_RE.test(url) && !bodyHasSections(options && options.body);
    const result = originalFetch.apply(this, arguments);

    if (isAppCartMutation) {
      result.then((res) => { if (res.ok) scheduleRefresh(); }).catch(() => {});
    }
    return result;
  };

  // Intercept XHR-based cart mutations (fallback for older app scripts)
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__cartSyncUrl = typeof url === 'string' ? url : String(url);
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this.__cartSyncUrl && CART_MUTATION_RE.test(this.__cartSyncUrl) && !bodyHasSections(body)) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) scheduleRefresh();
      });
    }
    return originalSend.apply(this, arguments);
  };

  // Also honor the standard refresh event. You can paste this into
  // Kite > Settings > Custom JS Scripts > "Execute Custom logic after free gift addition":
  //   document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  document.addEventListener('cart:refresh', scheduleRefresh);
})();

document.addEventListener('click', async (e) => {

  const btn = e.target.closest('.cart-recs__add');

  if (!btn || btn.disabled || btn.classList.contains('is-loading')) {
    return;
  }

  const variantId = btn.dataset.variantId;
  const originalText = btn.innerHTML;
  const cartDrawer = document.querySelector('cart-drawer');

  try {

    btn.disabled = true;
    btn.classList.add('is-loading');
    if (!btn.querySelector('.cart-recs__spinner')) btn.innerHTML = 'Adding...';

    const formData = {
      items: [{
        id: variantId,
        quantity: 1
      }],
      sections: cartDrawer ? cartDrawer.getSectionsToRender().map((s) => s.id) : [],
      sections_url: window.location.pathname
    };

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    if (!response.ok) {
      throw new Error('Add to cart failed');
    }

    const data = await response.json();

    btn.innerHTML = 'Added ✓';

    document.dispatchEvent(new CustomEvent('cart:update'));
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-progress',
        cartData: data,
        variantId: variantId
      });
    }

    if (cartDrawer) {
      const sectionsToRender = cartDrawer.getSectionsToRender
        ? cartDrawer.getSectionsToRender()
        : [];

      const sectionsResponse = await fetch(`${window.location.pathname}?sections=${sectionsToRender.map((s) => s.id).join(',')}`);
      const sectionsData = await sectionsResponse.json();

      cartDrawer.renderContents({ sections: sectionsData });
      cartDrawer.open();
    } else {
      window.location.reload();
    }

    setTimeout(() => {
      btn.innerHTML = originalText;
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }, 1200);

  } catch (error) {

    console.error(error);

    btn.innerHTML = 'Add';
    btn.disabled = false;
    btn.classList.remove('is-loading');
  }

});

document.addEventListener('change', async function (e) {

  if (!e.target.matches('.cart-frequency-select')) {
    return;
  }

  const lineKey =
    e.target.dataset.lineKey;

  const sellingPlan =
    Number(e.target.value);

  const cart =
    await fetch('/cart.js')
      .then(r => r.json());

  const item =
    cart.items.find(
      i => i.key === lineKey
    );

  if (!item) return;

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: lineKey,
      quantity: item.quantity,
      selling_plan: sellingPlan
    })
  });

  document
    .querySelector('cart-drawer')
    ?.renderContents(cart);
});

document.addEventListener('click', async function (e) {

  const btn =
    e.target.closest(
      '.upgrade-subscription-btn'
    );

  if (!btn) return;

  const lineKey =
    btn.dataset.lineKey;

  const sellingPlan =
    Number(
      btn.dataset.sellingPlan
    );

  const cart =
    await fetch('/cart.js')
      .then(r => r.json());

  const item =
    cart.items.find(
      i => i.key === lineKey
    );

  if (!item) return;

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: lineKey,
      quantity: item.quantity,
      selling_plan: sellingPlan
    })
  });

  location.reload();
});

(() => {
  const DURATION = 700;
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  let lastProgress = null;
  let lastCents = null;
  let currentBar = null;
  let frame = null;

  // The drawer swaps its own HTML on every cart change, so the new bar arrives
  // already at its final width. Repaint it at the previous value before the
  // browser gets a frame, then tween to the new one.
  function animate(bar) {
    const fill = bar.querySelector('.cart-progress__fill');
    const pill = bar.querySelector('.cart-progress__remaining');
    const dots = [...bar.querySelectorAll('.cart-progress__dot')];
    const labels = [...bar.querySelectorAll('.cart-progress__label')];
    const target = parseFloat(bar.dataset.progress) || 0;
    const targetCents = pill ? parseInt(pill.dataset.cents, 10) : null;
    const template = pill ? pill.textContent.trim() : '';
    const numberMatch = template.match(/[\d][\d.,\s]*/);
    const decimals = numberMatch && /[.,]\d{2}\s*$/.test(numberMatch[0].trim()) ? 2 : 0;

    const fromProgress = lastProgress === null ? target : lastProgress;
    const fromCents =
      lastCents === null || targetCents === null ? targetCents : lastCents;

    const apply = (value, cents) => {
      if (fill) {
        fill.style.width = `${value}%`;
        // The rounded cap's min-width would otherwise show on an empty cart
        fill.dataset.empty = value <= 0.001 ? 'true' : 'false';
      }
      dots.forEach((dot) => {
        const at = parseFloat(dot.dataset.position) || 0;
        dot.classList.toggle('cart-progress__dot--unlocked', value >= at - 0.01);
      });
      labels.forEach((label) => {
        const at = parseFloat(label.dataset.position) || 0;
        label.classList.toggle('cart-progress__label--unlocked', value >= at - 0.01);
      });
      if (pill && numberMatch && cents !== null && cents !== undefined) {
        pill.textContent = template.replace(
          numberMatch[0].trim(),
          (cents / 100).toFixed(decimals)
        );
      }
    };

    // The fresh markup already carries the new unlocked state. Rewinding it to
    // the previous value would animate backwards first, so the notch would read
    // as changing twice. Suppress transitions for the rewind, flush it, then
    // hand transitions back for the tween forwards.
    bar.classList.add('cart-progress--no-transition');
    apply(fromProgress, fromCents);
    void bar.offsetWidth;
    bar.classList.remove('cart-progress--no-transition');

    if (frame) cancelAnimationFrame(frame);

    if (fromProgress === target && fromCents === targetCents) {
      lastProgress = target;
      lastCents = targetCents;
      return;
    }

    const start = performance.now();
    const step = (now) => {
      const t = Math.min((now - start) / DURATION, 1);
      const eased = easeOutCubic(t);
      const value = fromProgress + (target - fromProgress) * eased;
      const cents =
        fromCents === null || targetCents === null
          ? null
          : Math.round(fromCents + (targetCents - fromCents) * eased);

      apply(value, cents);

      if (t < 1) {
        frame = requestAnimationFrame(step);
      } else {
        frame = null;
        if (pill) pill.textContent = template;
        lastProgress = target;
        lastCents = targetCents;
      }
    };
    frame = requestAnimationFrame(step);
  }

  // cart.js replaces the drawer without firing an event, so watch the DOM
  // instead of trusting any single refresh path to announce itself.
  function sync() {
    const bar = document.querySelector('#CartDrawer .cart-progress');
    if (!bar) {
      currentBar = null;
      return;
    }
    if (bar === currentBar) return;
    currentBar = bar;
    animate(bar);
  }

  const observer = new MutationObserver(sync);

  const startObserving = () => {
    const bar = document.querySelector('#CartDrawer .cart-progress');
    if (bar) {
      currentBar = bar;
      lastProgress = parseFloat(bar.dataset.progress) || 0;
      const pill = bar.querySelector('.cart-progress__remaining');
      lastCents = pill ? parseInt(pill.dataset.cents, 10) : null;
    }
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();
